import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-qrcode',
  templateUrl: './qrcode.component.html',
  styleUrls: ['./qrcode.component.sass']
})
export class QrcodeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
